/* Use green background for active filter buttons Oct 21, 2023 */
/* Amend to execute quick filters on the Front End Dec 21, 2024 */
<template lang="pug">
	div(class="task-nav")
		div(class="nav-header")
			div
					b-button(v-for="t in d_tabs" :key="t.ix" variant="none" :pressed="d_tabCurr.ix==t.ix"
						@click="d_tabCurr=t") {{t.lbl + (t.ix==1?c_activityName:'')}}
			slot(v-if="d_tabCurr.ix!=1" name="team-member-filter" :fTM="true")
		div(v-if="d_urlKey == 'cal'")
			b-card(class="tableTypes")
				b-card-header
					b-button-group
						span(v-for="(tt) in d_taskTables" :key="tt.key" 
							class="btn btn-outline-secondary"
							:class="d_tableKey==tt.key?'tab-btn-active':null"
							@click="m_taskTableClick(tt.key);"
							) {{tt.name}}
		div
			b-card
				b-card-header(no-body v-for="tabTbl in [d_tabCurr]" :key="tabTbl.ix")
					b-button-group
						span(v-for="(fb, ix) in tabTbl.filterBtns" :key="ix" 
							class="btn btn-outline-secondary"
							:class="fb.state?'btn-active':null"
							:title="tabTbl.fn_fbTitle(fb)"
							@click="tabTbl.fn_fbClick(fb)"
							) {{fb.tsNm}}
						span(class="btn btn-link" title="Select All" @click="tabTbl.fn_tglAll(true)") All
						span(class="btn btn-link" title="Clear All" @click="tabTbl.fn_tglAll(false)") Clear
				b-card-body(:key="d_prntRecKey")
					div(class="note") 
						span {{c_tbNote}}
						kt-tt-info(:p_infoTxt="c_tbInfo")
					kt-tasks(
						:p_prntRecKey="d_prntRecKey"
						:p_qryPrms="c_qryPrms"
						:p_taskIdKey="c_tblIdKey"
					)
</template>

<script>
import {fn_getHashBase, fn_saveUserOpts} from "@/utils/util.js";
import {userInfo,fn_appEnt, refData, userSettings} from "@/utils/ref-data.js";
import KTTasks from "@/components/Ctrl/KT-Tasks.vue";

export default {
	name: "task-nav",
	components: {
		'kt-tasks': KTTasks,
	},
	created() {
		fn_setPrntRecKey(this);

		//Kepp Order
		this.d_tabs = fn_getTabs(this);
		var d_qryPrms;
		if(window.localStorage.getItem(window.location.href+'-quickFilter')) {
		
			console.log('In window.localStorage');
			
			try{
				d_qryPrms=JSON.parse(window.localStorage.getItem(window.location.href+'-quickFilter'));
				} catch(err){d_qryPrms=null;}
		
			console.log('d_qryPrms');
			console.log(d_qryPrms);
			if(d_qryPrms) {
				this.d_tabs[d_qryPrms.ix].qryPrms=d_qryPrms;
				this.d_tabCurr = this.d_tabs[d_qryPrms.ix];
		
			} 
		
		} else this.d_tabCurr = this.$parent.d_cuFilter ? this.d_tabs[1] : this.d_tabs[0];
	},
	data() {
		return {
			d_prntRecKey: null,
			d_tabs: [],
			d_tabCurr: [],
			d_teamMemberId: userInfo.getUserInfo().teamMember.teamMemberId,
			d_withArchived:false,
			d_taskTables:[	{key:'cal',name:'Calendar'},
							{key:'oppr',name:'Opportunities'},
							{key:'proj',name:'Projects'},
							{key:'acct',name:'Accounts'},
						],
			d_tableKey:'cal',
			d_urlKey:null,
		};
	},
	computed: {
		c_rec_Activity() {return fn_appEnt('task', this.d_prntRecKey).label;},
		c_activityName(){return this.d_urlKey=='cal'?'Activities':fn_appEnt('task', this.d_prntRecKey).label;},
		c_tblIdKey(){return this.d_tabCurr.tblIdKey;},
		c_qryPrms(){return this.d_tabCurr.qryPrms;},
		c_tbNote(){return this.d_tabCurr.tbNote;},
		c_tbInfo(){return this.d_tabCurr.fn_tbInfo();},
	},
	methods: {
		m_tabClick(t){
			this.d_tabCurr=t;
			window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(this.d_tabCurr.qryPrms));
		},
		m_taskTableClick(k){this.d_tableKey=k;
							this.d_prntRecKey=k;
						}
	},
	watch: {
		$route(nv) {
			// refresh component when page changes
			fn_setPrntRecKey(this);

			this.d_tabs.forEach(x => {
				x.filterBtns.forEach(fb => fb.state = false);
				fn_setFilters(x, this);
				fn_setTabProps(x, this);
			});
		},
		d_tabCurr(nv, ov) {
			if (nv.ix == 1) this.$parent.d_cuFilter = true;
			else if (ov.ix == 1 || nv == 0) this.$parent.d_cuFilter = null;

			if (ov.ix >= 0) fn_setTabProps(nv, this);
			window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(nv.qryPrms));
		},
		'$parent.c_cutmKey'(nv, ov) {
			let ct = this.d_tabCurr;
			if (ct.ix == 0 && ov != -1) fn_setTabProps(ct, this);
		},
		d_prntRecKey(nv){
		this.d_tabs.forEach(x => {
				x.filterBtns.forEach(fb => fb.state = false);
				fn_setTabProps(x, this);
			});
		
		},
	}
};

function fn_setPrntRecKey(vc) {
	let hb = fn_getHashBase(vc);
	vc.d_prntRecKey = hb.substring(0, hb.indexOf('-'));
	vc.d_urlKey = hb.substring(0, hb.indexOf('-'));
}

function fn_getTabs(vc) {
	let tbInfoHelper = (who) => `${vc.c_rec_Activity} on which ${who} the Activity Lead or an Assignee`;
	let tabs = [
		{
			ix: 0,
			lbl: 'All',
			tblIdKey: '',
			fn_tbInfo: () => !vc.$parent.d_tmFilter ? null : tbInfoHelper('the selected Team Member is'),
			fn_qryPrms: (tab) => {
				let tmf = vc.$parent.d_tmFilter;
				return {
					ix:0,
					taskStatusIds: fn_tsPrms(tab),
					teamMemberId: tmf ? tmf.teamMemberId : null,
				};
			}
		},
		{
			ix: 1,
			lbl: 'My ',
			tblIdKey: '-currentUser',
			fn_tbInfo: () => tbInfoHelper('you are'),
			fn_qryPrms: (tab) => {
				return {
					ix:1,
					taskStatusIds: fn_tsPrms(tab),
					currentUser: true,
					teamMemberId:vc.d_teamMemberId,
				};
			}
		}
	];
	tabs.forEach(x => {
		x.filterBtns = refData.taskStatuses.map(ts => ({
			tsNm: ts.name,
			tsId: ts.id,
			state: false
		}));
		x.fn_fbTitle = (fb) => `Filter "${fb.tsNm}" Activities`;
		x.fn_tglAll = (tgl) => {
			vc.d_tabCurr.filterBtns.forEach(x => x.state = tgl);
			if (x.qryPrms.taskStatusIds) fn_setTabProps(x, vc);
			fn_saveFilters(vc);
		};
		x.fn_fbClick = (fb) => {
			fb.state = !fb.state;
			fn_setTabProps(x, vc);
			window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(vc.d_tabCurr.qryPrms));
			fn_saveFilters(vc);
		};
		fn_setFilters(x, vc);
		fn_setTabProps(x, vc);
	});
	return tabs;
}

//Activity Status Filter Helpers
function fn_tsPrms(tab) {
	let fb = tab.filterBtns || [];
	let tsIds = fb.filter(x => x.state).map(x => x.tsId);
	return tsIds.length == 0 || tsIds.length == fb.length ? null : JSON.stringify(tsIds);
}
function fn_tsFilterNote(tab, vc) {
	console.log('In fn_tsFilterNote');
	let fb = tab.filterBtns || [];

	let tmfLbl = vc.$parent.c_tmFilterLbl;
	console.log(tmfLbl);
	let note = (tmfLbl ? tmfLbl.slice(0, -10) : '') + vc.c_rec_Activity;
	//if(vc.d_urlKey) note = fn_appEnt('task', vc.d_urlKey).label;
	console.log(note);
	console.log(fn_appEnt('task', vc.d_urlKey).label);
	let tsNms = fb.filter(x => x.state).map(x => x.tsNm);
	let len = tsNms.length;
	if (len == 0 || len == fb.length) return (tmfLbl ? '' : 'All ') + note + ' in all Statuses';
	else return note + ` in the "${tsNms.join('", "')}" Status${(len > 1 ? 'es' : '')}`;
}
function fn_setTabProps(tab, vc) {
	tab.qryPrms = tab.fn_qryPrms(tab);
	tab.tbNote = fn_tsFilterNote(tab, vc);
}

function fn_setFilters(tab, vc) {
	let prop = vc.d_prntRecKey + 'TaskNavFilters';
	let uonf = userSettings.userOptions[prop] || {};
	uonf = uonf[tab.ix] || [];
	uonf.forEach(x => {
		let fb = tab.filterBtns.filter(fb => fb.tsId == x)[0];
		if (fb) fb.state = true;
	});
}
function fn_saveFilters(vc) {
	let val = {};
	vc.d_tabs.forEach(t => {
		val[t.ix] = t.filterBtns.filter(x => x.state).map(x => x.tsId);
	});
	let prop = vc.d_prntRecKey + 'TaskNavFilters';
	fn_saveUserOpts(prop, null, val);
}
</script>
<style lang="less">
.task-nav {
	.card-body > .note {
		text-align: left;
		font-size: 0.9em;
		padding: 0.4em 0;
		line-height: 1.5em;
	}
}
.btn-active{color:white;
	background-color:#28a745;
	}
.tab-btn-active{color:white;
		background-color:purple;
	}
.tableTypes{
			margin-top:0px !important;
			margin-bottom:0px !important;
			width:25%;
		}
</style>